module.exports = __webpack_public_path__ + "img/desktop-simulator.b8d4c761.png";